<template>
  <v-app>
    <NavbarComponent @toggle-drawer="toggleDrawer" :drawer="drawer"/>

    <v-main>
      <v-container fluid class="pa-0">
        <router-view />
      </v-container>
    </v-main>

    <FooterComponent />
  </v-app>
</template>

<script>
import NavbarComponent from '@/components/Navbar.vue';
import FooterComponent from '@/components/Footer.vue';
import { mapGetters, mapActions } from 'vuex';

export default {
  name: 'App',
  components: {
    NavbarComponent,
    FooterComponent,
  },
  data() {
    return {
      drawer: false,
    };
  },
  computed: {
    // Vuex getters'ı component'e map et
    ...mapGetters('auth', ['isAuthenticated', 'currentUser']),
  },
  methods: {
    // Vuex actions'ı component'e map et
    ...mapActions('auth', ['logout']),
    toggleDrawer() {
      this.drawer = !this.drawer;
    },
  },
  created() {
    this.$store.dispatch('auth/tryAutoLogin');
  },
};
</script>

<style>
/* Global styles */
.v-btn {
  margin: 0 4px;
}
</style>
